var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-table-cell-boolean data-table-cell-group group"},[_c('ui-icon',{class:_vm.classes,attrs:{"glyph":_vm.icon,"title":_vm.title}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }